export default __webpack_public_path__ + "static/media/welcome-unplanned.653ae4db.svg";